<template>
  <div class="page-container">
    <div class="page-title">
      {{ $t('menu.payment_slip_validation_list') }}
    </div>
    <PaymentSlipValidationDetails />
  </div>
</template>

<script>
export default {
  name: 'Data_Payment_Slip_Validation',
  components: {
    PaymentSlipValidationDetails: () => import('./components/PaymentSlipValidationDetails.vue')
  }
}
</script>

<style scoped>
.page-container{
  margin: 40px 57px 50px 32px;
}
.page-container .page-title{
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
</style>
